import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Col } from 'bootstrap';
import { RowTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import UserSessionStore from 'flux/stores/UserSessionStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetResponsiveStore from 'flux/stores/cuesheet/CuesheetResponsiveStore';
import CuesheetMixin from 'main/components/show/cuesheet/cuesheetMixin.js';
import CueListItem from 'main/components/show/cuesheet.responsive/cueListItem.jsx';
import AddItemButton from 'main/components/show/cuesheet/addItemButton.jsx';
import Spinner from 'shared/components/misc/simpleSpinner.jsx';

import keyIn from 'shared/lib/immutable/keyIn';

/**
 * Responsive cue list component
 *
 */
export default React.createClass({
  mixins: [
    Reflux.connectFilter(UserSessionStore, 'userId', (state) =>
      state.get('_id'),
    ),
    Reflux.connectFilter(CuesheetResponsiveStore, 'showDetail', (st) =>
      st.get('showDetail'),
    ),
    Reflux.connectFilter(EventViewStore, 'event', (st) =>
      st.filter(keyIn('twentyFourHourClock')),
    ),
    Reflux.connect(CuesheetStore, 'cuesheet'),
    PureRenderMixin,
    CuesheetMixin,
  ],

  render() {
    let rows = this._getCueStateField('rows');

    if (!rows || this._getCueStateField('loading')) {
      return <Spinner />;
    }

    let showDetailForSmallScreens = this.state.showDetail;

    return (
      <Col
        xs={24}
        sm={12}
        md={12}
        lg={12}
        className={classNames('csr-cue-list', {
          'hidden-xs': showDetailForSmallScreens,
        })}
      >
        {this._getListNode()}
      </Col>
    );
  },

  _getListNode() {
    let event = (event = this.state.event);

    return (
      <CueListInner
        twentyFourHourClock={event.get('twentyFourHourClock')}
        userId={this.state.userId}
        cueState={this._getCueState()}
      />
    );
  },
});

/**
 * The inner cuesheet list
 */
let CueListInner = React.createClass({
  mixins: [CuesheetMixin, PureRenderMixin],

  render() {
    const { cueState, userId } = this.props;

    const rows = cueState.get('rows'),
      rowMap = cueState.get('rowMap'),
      show = cueState.get('show'),
      displayStartTime = show.get('displayStartTime'),
      displayPresetDuration = show.get('displayPresetDuration'),
      durationDisplayType = show.get('durationDisplayType'),
      presetDurationDisplayType = show.get('presetDurationDisplayType'),
      displayDuration = show.get('displayDuration'),
      twentyFourHourClock = this.props.twentyFourHourClock;

    let listNodes = rows.map((rowSpec, rowIndex) => {
      const item = rowMap.getIn(rowSpec.get('path')),
        rowType = rowSpec.get('type');

      return (
        <CueListItem
          key={'cue-list-item-' + item.get('_id')}
          rowIndex={rowIndex}
          userId={userId}
          isCopied={rowSpec.get('copied')}
          isTracked={rowSpec.get('tracked')}
          isTitle={rowType === RowTypes.TitleItem}
          displayStartTime={displayStartTime}
          displayDuration={displayDuration}
          displayPresetDuration={displayPresetDuration}
          durationDisplayType={durationDisplayType}
          presetDurationDisplayType={presetDurationDisplayType}
          twentyFourHourClock={twentyFourHourClock}
          item={item}
        />
      );
    });

    listNodes = listNodes.push(
      <div className="csr-rows-add-btn-container">
        <AddItemButton />
      </div>,
    );

    return <div>{listNodes}</div>;
  },
});
